(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_md-menu-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('md-menu-drawer')) {
    class MdMenuDrawer extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('.md-menu-drawer__dialog');
        this.toggle = this.querySelector('[data-md-menu-open]');
        if (!this.dialog || !this.toggle) return;

        this.toggle.addEventListener('click', this.open);
        this.dialog.addEventListener('click', this.onDialogClick);
        this.dialog.addEventListener('cancel', this.onCancel);
        this.indexAnimated();
      }

      disconnectedCallback() {
        this.toggle?.removeEventListener('click', this.open);
        this.dialog?.removeEventListener('click', this.onDialogClick);
        this.dialog?.removeEventListener('cancel', this.onCancel);
        this.unlockScroll();
      }

      /** Numera gli elementi animati per lo scaglionamento, nell'ordine del DOM. */
      indexAnimated() {
        const items = this.dialog.querySelectorAll('[data-md-animate]');
        items.forEach((item, index) => item.style.setProperty('--md-i', String(index)));
      }

      get duration() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return 0;
        const value = getComputedStyle(this).getPropertyValue('--md-menu-duration');
        return Number.parseFloat(value) || 600;
      }

      open = () => {
        if (this.dialog.open) return;
        this.indexAnimated();
        this.lockScroll();
        this.dialog.showModal();
        this.toggle.setAttribute('aria-expanded', 'true');
        // Due frame: lo stato chiuso deve essere dipinto prima della transizione.
        requestAnimationFrame(() => requestAnimationFrame(() => (this.dataset.state = 'open')));
      };

      close = () => {
        if (!this.dialog.open || this.closing) return;
        this.closing = true;
        this.dataset.state = 'closing';
        window.setTimeout(() => {
          this.dialog.close();
          delete this.dataset.state;
          this.closing = false;
          this.toggle.setAttribute('aria-expanded', 'false');
          this.unlockScroll();
        }, this.duration * 0.8);
      };

      onCancel = (event) => {
        event.preventDefault();
        this.close();
      };

      onDialogClick = (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;

        const submenuToggle = target.closest('[data-md-submenu-toggle]');
        if (submenuToggle) {
          this.toggleSubmenu(submenuToggle);
          return;
        }

        if (target.closest('[data-md-menu-close]')) {
          this.close();
          return;
        }

        // Navigando verso un'ancora della stessa pagina il menu si chiude.
        const link = target.closest('a[href]');
        if (link && link.getAttribute('href')?.includes('#')) this.close();
      };

      toggleSubmenu(button) {
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        if (!panel) return;
        const expanded = button.getAttribute('aria-expanded') !== 'true';

        this.dialog
          .querySelectorAll(`[aria-controls="${button.getAttribute('aria-controls')}"]`)
          .forEach((control) => control.setAttribute('aria-expanded', String(expanded)));
        panel.toggleAttribute('data-open', expanded);
        panel.querySelector('.md-menu-drawer__sub-inner')?.toggleAttribute('inert', !expanded);
      }

      lockScroll() {
        const root = document.documentElement;
        const scrollbar = window.innerWidth - root.clientWidth;
        this.previousOverflow = root.style.overflow;
        this.previousPadding = root.style.paddingRight;
        root.style.overflow = 'hidden';
        if (scrollbar > 0) root.style.paddingRight = `${scrollbar}px`;
      }

      unlockScroll() {
        const root = document.documentElement;
        if (this.previousOverflow === undefined) return;
        root.style.overflow = this.previousOverflow;
        root.style.paddingRight = this.previousPadding;
        this.previousOverflow = undefined;
      }
    }

    customElements.define('md-menu-drawer', MdMenuDrawer);
  }
  } catch(e) { console.error(e); }
})();

})();
